import React, { useState } from 'react';
import Icon from '@welldev-group/rcl-icon';
import Button from '@welldev-group/rcl-button';
import IconButton from '@welldev-group/rcl-icon-button';
import { I18nText } from '@welldev-group/react-comp-lib';
import Modal from '@welldev-group/rcl-modal';
import SpinnerIcon from 'affiliateIcons/spinner.svg';
import PropTypes from 'prop-types';
import routes from '../../../shared/routes';
import httpClient from '../../../shared/libraries/httpClient';

const ChannelDeleteModal = props => {
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteDisable, setDeleteDisable] = useState(false);

  const onModalClose = () => {
    setModalOpen(false);
  };

  const onModalOpen = () => {
    setModalOpen(true);
  };

  const deleteCredential = (supplier, id) => {
    httpClient
      .delete(routes.credentials.delete({ supplier, id }))
      .then(({ data }) => {
        if (data.error === null) {
          props.fetchCredentials(props.affiliateId);
          setModalOpen(false);
          setDeleteDisable(false);
        }
      })
      .catch(({ response }) => {
        if (response.status === 422) {
          setDeleteDisable(false);
        }
      });
  };

  const handleDeleteCredential = () => {
    setDeleteDisable(true);
    deleteCredential(props.supplier, props.id);
  };
  return (
    <div className="channel-modal__container">
      <IconButton
        icon={<Icon name="delete" />}
        size="large"
        version="v2"
        standalone={true}
        onClick={onModalOpen}
        disabled={props.disabled}
      />
      <Modal
        className="modal__wrapper modal__wrapper-small"
        isVisible={modalOpen}
        onOutsideClick={onModalClose}
      >
        <>
          <div className="modal__header">
            <Modal.Title>
              {I18n.t('components.channel.delete_modal.header', {
                humanized_supplier: props.humanizedSupplier,
              })}
            </Modal.Title>
            <div
              onClick={() => setModalOpen(false)}
              onKeyDown={() => setModalOpen(false)}
              role="presentation"
            >
              <Icon name="close" size="normal" />
            </div>
          </div>
          <Modal.Content>
            <div className="grid">
              <div className="col-12 col-bleed">
                <I18nText id="channel.delete_modal.text" />
              </div>
            </div>
          </Modal.Content>
          <Modal.Footer>
            <div className="col-12 col-bleed-x channel-modal__fields">
              <Button
                onClick={handleDeleteCredential}
                label={
                  deleteDisable ? (
                    <>
                      <I18nText id="channel.label.deleting" />
                      <img
                        src={SpinnerIcon}
                        alt="spinner"
                        className="channel-modal__spinner"
                      />
                    </>
                  ) : (
                    <I18nText id="channel.label.delete" />
                  )
                }
                version="v2"
                size="small"
                type="primary"
                disabled={deleteDisable}
              />

              <Button
                onClick={onModalClose}
                label={<I18nText id="channel.label.cancel" />}
                version="v2"
                size="small"
              />
            </div>
          </Modal.Footer>
        </>
      </Modal>
    </div>
  );
};

ChannelDeleteModal.defaultProps = {
  disabled: false,
};

ChannelDeleteModal.propTypes = {
  fetchCredentials: PropTypes.func.isRequired,
  affiliateId: PropTypes.number.isRequired,
  supplier: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  humanizedSupplier: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default ChannelDeleteModal;
